import React from 'react';
import { Flexbox } from 'cw-ui-core';
import css from './DotCommon.scss';
import cx from 'classnames';

const DotCommon = props => {
    return (
        <Flexbox
            className={cx(css.wrap, props.className)}
            onClick={props.onClick}
            automationName={props.automationName}>
            {props.hasIcon ? (
                props.iconImage
            ) : (
                <span className={css.statusColor} style={{ backgroundColor: props.colorForStatus }} />
            )}
            {props.children}
        </Flexbox>
    );
};

export default DotCommon;
